import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, ViewRef } from '@angular/core';
import { TranslatorService } from '../../../services/translator_service';
import { ResponsiveService } from '../../../services/responsive.service';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ApiQuery } from '../../../web-services/api/api.query';
import _ from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SelectionModel } from '@angular/cdk/collections';
import moment from 'moment';
import { UtilService } from '../../../services/util.service';
import { ApiService } from '../../../web-services/api/api.service';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSortModule, Sort } from '@angular/material/sort';
import { Pagination } from '../../pagination/pagination';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'app-inventory-bins',
  imports: [CommonModule, TranslatePipe, RTLDivDirectiveDirective,FormsModule,Pagination,MatTableModule,MatSortModule,
    MatCheckboxModule,LottieComponent,ReactiveFormsModule,MatDialogModule
  ],  
  templateUrl: './inventory-bins.html',
  styleUrl: './inventory-bins.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InventoryBins {
  isMobile: boolean;
  translationsObj;
  currentLang;
  tempFilter = '';
  filteredBinsData: Array<object> = [];
  dataSource: any = new MatTableDataSource<any>();
  startIndexTableData = 0;
  endIndexTableData = 9;
  private readonly destroy$ = new Subject<void>();
  selection = new SelectionModel<Element>(true, []);
  binsBackUp: Array<any> = [];
  binCollectionDaysCol: boolean = false;
  binBlackStatusCol: boolean = false;
  binsData: Array<any> = [];
  showLoadingForCurrentCapacityAnalysis: boolean = true;
	showLoadingForCollectionDays:boolean = true;
	capacityDisplayType: number = 0;
	usageType = 1;
	user_role_id = 0;
	ElForm: FormGroup;
	blackStatusValue:number = 90;
	binFullInfo: any;
	binNameCol:boolean = false;
	binSiteCol:boolean = false;
	binIdCol:boolean = false;
	binDeviceIdCol: boolean = false;
	binTypeCol:boolean = false;
	neighborhood:boolean = false;
	binInstallDateCol:boolean = false;
	binAvgRateCol:boolean = false;
	binAvgUsageRateCol:boolean = false;
	binCollectionFrequencyCol:boolean = false;
	avgDailyRateDunamCol:boolean = false;
	binPredictedTimeForMaxAllowedCapacityCol: any;
  binCollectionModeCol : boolean = false;
	options: AnimationOptions = {
		path: "/assets/images/skeleton.json"
	};
  displayedColumns = ['select', 'name','site_name', 'id','device_id','type', 'address','neighborhood','cluster_id','description','size','installation_Date', 'last_collection','last_refill', 'last_update', 'status','avg_rate','avg_usage_rate','collection_frequency','emptying_dunam','predicted_time_for_max_allowed_capacity','black_status','collection_mode','collection_days'];
	editBlackStatusFlag:boolean = true;
	isNeighborhoodChecked: any;
	isBinNameColChecked: any;
	isBinSiteColChecked: any;
	isBinIdColChecked: any;
	isBinTypeColChecked: any;
	isBinInstallDateColChecked: any;
	isBinAvgRateColChecked: any;
	isBinAvgUsageRateChecked: any;
	isBinCollectionFrequencyChecked: any;
	isAvgDailyRateDunamColChecked: any;
	isBinPredictedTimeForMaxAllowedCapacityChecked: any;
	isBlackStatusChecked: any;
	isBinCollectionModeChecked: any;
	isBinCollectionDaysChecked: any;
	isBinDeviceIdColChecked: any;

  constructor(private translator: TranslatorService, private responsiveService: ResponsiveService, @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<InventoryBins>, private apiQuery: ApiQuery, private utilService: UtilService,
    private cd: ChangeDetectorRef, private apiService: ApiService,private fb: FormBuilder) {
    this.dialogRef.disableClose = true;
    this.translator.currentLangEmitter$
    .pipe(takeUntil(this.destroy$))
    .subscribe(async value=>{						
      this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
      this.currentLang = value;
    })
    this.ElForm = this.fb.group({
      blackStatusBin :new FormControl(90)
    });
  }

  ngOnInit() {
    this.onResize();
    this.responsiveService.checkWidth();

    this.apiService?.GetDynamicColumns()?.pipe(takeUntil(this.destroy$)).subscribe((column:any) => {
			if(column.DynamicColumns != null && column.DynamicColumns.length > 0){
				_.each(column.DynamicColumns, (item) => {	
					if(item.is_activate_for_current_user){
						this.showColumn(item["dynamic_column_id"].toString());
					}				
				});
			}				
		});

    this.apiQuery.user$.pipe(takeUntil(this.destroy$)).subscribe(user => {
			if (!user) return;
			this.capacityDisplayType = user["user_default_capacity_type_id"];
			if(user["usage_type_id"] != 1){
				this.usageType = user["usage_type_id"];
			}	
			this.user_role_id = user["user_role_id"];
    });

    this.apiQuery.filteredBins$.pipe(takeUntil(this.destroy$)).subscribe((bins) => {
      this.selection.clear();
      if (bins.length == 0) return;
      this.binsBackUp = bins;
      if (this.binsBackUp.length == 0) return;

      _.each(this.binsBackUp, (bin) => {
        bin["calcDiff_lastCollection"] = this.calcDiff(bin["Bin_live_Data"].last_collection_time);
        bin["calcDiff_lastUpdate"] = this.calcDiff(bin["Bin_live_Data"].Transmission_data.last_transmission_time);
      });

      if (this.binCollectionDaysCol) {
        this.getCollectionDays(true);
      } else if (this.binBlackStatusCol) {
        this.getBlackStatus();
      } else {
        this.initBinsTable(this.binsBackUp);
      }
      this.cd.detectChanges();        
    });
  }

  onResize() {
    this.responsiveService.getMobileStatus().pipe(takeUntil(this.destroy$)).subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  ngOnDestroy(){
		this.destroy$.next();
		this.destroy$.complete();
		if (!(this.cd as ViewRef).destroyed) {			
			this.cd.detectChanges();
		}
	}

  closeModal = () => {
    let data = {
      tabsToCompare: this.data.chosenBins
    }
    this.dialogRef.close(data);
  }

  applyChanges(){
    if(this.selection.selected.length == 0){
			return;
		}
    let data = {
      tabsToCompare: this.selection.selected
    }
    this.dialogRef.close(data);
  }

  toggleEditableSite(value:any){
    this.binSiteCol = value;
    this.setColumnForUser("10",this.binSiteCol);
  }

  toggleEditableBlackStatus(value:any){
    this.binBlackStatusCol = value;
    if(value){
      this.getBlackStatus();
    }
  }

  
  toggleEditableCollectionDays(value:any){
    this.binCollectionDaysCol = value;
    if(value){
      this.getCollectionDays(true);
    }
  }  

  
  toggleEditableDeviceId(value:any){
    this.binDeviceIdCol = value;
    this.setColumnForUser("7",this.binDeviceIdCol);
  }

  toggleEditablePredictedTimeForMaxAllowedCapacity(value:any){
    this.binPredictedTimeForMaxAllowedCapacityCol = value;
    this.setColumnForUser("14",this.binPredictedTimeForMaxAllowedCapacityCol);
  }

  toggleEditableAvgDailyRateDunam(value:any){
    this.avgDailyRateDunamCol = value;
    this.setColumnForUser("9",this.avgDailyRateDunamCol);
  }

  toggleEditableCollectionMode(value:any){
    this.binCollectionModeCol = value;
    this.setColumnForUser("5",this.binCollectionModeCol);
  }
  
  toggleEditableAvgUsageRate(value:any){
    this.binAvgUsageRateCol = value;
    this.setColumnForUser("11",this.binAvgUsageRateCol);
  }
  
  toggleEditableAvgRate(value:any){
    this.binAvgRateCol = value;
    this.setColumnForUser("4",this.binAvgRateCol);
  }

  toggleEditableInstallation(value:any){
    this.binInstallDateCol = value;
    this.setColumnForUser("13",this.binInstallDateCol);
  }
  
  toggleEditableCollectionFrequency(value:any){
    this.binCollectionFrequencyCol = value;
    this.setColumnForUser("12",this.binCollectionFrequencyCol);
  }

  toggleEditableName(value:any){
    this.binNameCol = value;
    this.setColumnForUser("6",this.binNameCol);
  }

  toggleEditableType(value:any){
    this.binTypeCol = value;
    this.setColumnForUser("3",this.binTypeCol);
  }

  toggleEditableId(value:any){
    this.binIdCol = value;
    this.setColumnForUser("2",this.binIdCol);
  }

  toggleEditable(value:any) {
		this.neighborhood = value;
		this.setColumnForUser("1",this.neighborhood);
   }


  setColumnForUser(id:any,command:any){
		let dataToSend:any = {};
		if(command){
			dataToSend["dynamic_column_id_list"] = [id];
			dataToSend["is_dynamic_columns_active"] = 1;
			this.apiService.SetUserDynamicColumns(dataToSend);
		}else{
			dataToSend["dynamic_column_id_list"] = [id];
			dataToSend["is_dynamic_columns_active"] = 0;
			this.apiService.SetUserDynamicColumns(dataToSend);
		}		
	}

  showDropDown(){
		let wrappers = document.getElementsByClassName('mat-mdc-tab-body-wrapper') as HTMLCollectionOf<HTMLElement>;
		_.each(wrappers, (wrapper) => {
			wrapper.style.overflow = 'auto';
		});
		this.editBlackStatusFlag = true;
	}

	getImg(value:any){			
		if(value == 2){
			return "assets/images/dashboard/selected.svg";
		}else{
			return "assets/images/dashboard/notSelected.svg";
		}
	}

  getTitle(elm:any){
		if(elm.Bin_Restrictions.collection_mode == 1){
			return this.currentLang == 'iw' ? elm.Bin_Restrictions.removed_bin_reason_type_name_hebrew : elm.Bin_Restrictions.removed_bin_reason_type_name;
		}
	}

  showColumn(value:any){
		switch(value) {
			case '1':
				this.neighborhood = true;
			  break;
			case '2':
				this.binIdCol = true;
			  break;
			case '3':
				this.binTypeCol = true;
				break;	
			case '4':
				this.binAvgRateCol = true;
				break;
			case '5':
				this.binCollectionModeCol = true;
				break;
			case '6':
				this.binNameCol = true;
				break;
			case '7':
				this.binDeviceIdCol = true;
				break;
			case '8':
				this.binCollectionDaysCol = false;
				break;
			case '9':
				this.avgDailyRateDunamCol = true;
				break;
			case '10':
				this.binSiteCol = true;
				break;
			case '11':
				this.binAvgUsageRateCol = true;
				break;
			case '12':
				this.binCollectionFrequencyCol = true;
				break;
			case '13':
				this.binInstallDateCol = true;
				break;
			case '14':
				this.binPredictedTimeForMaxAllowedCapacityCol = false;
				break;
			case '15':
				this.binBlackStatusCol = false;
				break;
		  }
	}

  editBlackStatus(){
		this.editBlackStatusFlag = false;
	}

  getProgressBarStyleInternal = (binInfo: any) => {		
		if(!this.isMobile){
			if (binInfo.bin_color == "GREEN") {
				return { 'background-color': '#14C264', 'width': binInfo.status + '%' };
			} else if (binInfo.bin_color == "YELLOW") {
				return { 'background-color': '#FAB300', 'width': binInfo.status + '%' };
			}
			return { 'background-color': '#E01B09', 'width': binInfo.status + '%' };
		}else{
			if (binInfo.bin_color == "GREEN") {
				return { 'color': '#14C264'};
			} else if (binInfo.bin_color == "YELLOW") {
				return { 'color': '#FAB300' };
			}
			return { 'color': '#E01B09' };
		}
	}

  private updateTableData(): void {
    const tableData = [];
    const tempSearch = new MatTableDataSource<any>(this.binsData || []);
    tempSearch.filter = this.tempFilter;
    this.filteredBinsData = tempSearch.filteredData;
    for (let index = this.startIndexTableData; index <= this.endIndexTableData; index++) {
      if (tempSearch.filteredData[index]) {
        tableData.push(tempSearch.filteredData[index]);
      }
    }
    this.dataSource = tableData.length > 0 ? new MatTableDataSource<any>(tableData) : new MatTableDataSource<any>([]);
    this.dataSource["AllData"] = new MatTableDataSource<any>(tempSearch.filteredData);
  }

  onPageChange = (dataTableIndexes: any) => {
    this.startIndexTableData = dataTableIndexes.startIndex;
    this.endIndexTableData = dataTableIndexes.endIndex;
    this.updateTableData();
  }

  submitBlackStatus(){
		if(this.ElForm.getRawValue()['blackStatusBin'] < 90 || this.ElForm.getRawValue()['blackStatusBin'] > 100){
			return;
		}else{
			this.blackStatusValue = this.ElForm.getRawValue()['blackStatusBin'];
			this.getBlackStatus();
		}
	}

  applyFilter = (filterValue: any) => {
    filterValue = filterValue.value;
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.tempFilter = filterValue;
    this.updateTableData();
    setTimeout(() => {
      this.cd.detectChanges();
    }, 0);
  }

  resetBlackStatus() {
    _.each(this.binsBackUp, (basicBin) => {
      basicBin["over_flow_dates"] = null;
      basicBin["analysis_time_span_in_days"] = null;
    });
  }

  getBlackStatus() {
    this.resetBlackStatus();
    this.showLoadingForCurrentCapacityAnalysis = true;
    let chosenSites: any = [];
    _.each(JSON.parse(sessionStorage.getItem("chosenSites")), (site) => {
      chosenSites.push(site.site_id);
    });
    let request = {
      site_id: chosenSites,
      capacity_in_percent: this.ElForm.getRawValue()['blackStatusBin']
    };
    this.apiService.getCurrentCapacityAnalysis(request)?.pipe(takeUntil(this.destroy$)).subscribe((v: any) => {
      this.showLoadingForCurrentCapacityAnalysis = false;
      _.each(this.binsBackUp, (basicBin) => {
        _.each(v.CapacityAnalysisInfo, (info) => {
          _.each(info.binsWorkPlanCapacityAnalysis, (item) => {
            if (item.bin_id == basicBin["bin_id"] && info.site_id == basicBin["site_id"]) {
              basicBin["over_flow_dates"] = item.over_flow_dates;
              basicBin["analysis_time_span_in_days"] = info.analysis_time_span_in_days;
            }
          });
        });
        if (basicBin["over_flow_dates"] == null) {
          basicBin["over_flow_dates"] = 0;
          basicBin["analysis_time_span_in_days"] = 0;
        }
      });
      _.each(_.groupBy(this.binsBackUp, item => `${item.cluster_id},${item.site_id}`), (clusters) => {
        let cluster_avg = 0;
        _.each(clusters, (bin) => {
          if (this.capacityDisplayType != 0) {
            cluster_avg += bin["Bin_live_Data"].fill_level_percent * bin["Bin_thresholds"].bin_max_capacity_in_liters / 100;
          } else {
            cluster_avg += bin["Bin_live_Data"].fill_level_percent;
          }
        });
        _.each(clusters, (bin) => {
          bin["cluster_avg"] = cluster_avg / clusters.length;
          bin["number_of_bins_in_cluster"] = clusters.length;
        });
      });
      this.initBinsTable(this.binsBackUp);
    });
  }

  initBinsTable(bins: any) {
    let binsFiltered = [];
    this.binFullInfo = bins;

    binsFiltered = _.map(bins, b => {
      return {
        bin_name: b["bin_name"],
        site_name: b["site_name"],
        bin_id: b["bin_id"],
        device_id: b["device_id"],
        bin_type: b["bin_type_name"],
        address: b["Bin_location"].bin_address,
        neighborhood: b["Bin_location"].bin_neighbourhood,
        lat: b["Bin_location"].bin_latitude,
        lon: b["Bin_location"].bin_longitude,
        description: b["bin_description"],
        bin_installation_date: this.currentLang != 'iw' ? this.utilService.convertDateEnglishWithoutTime(b["bin_installation_date"]) : this.utilService.convertDateHebrewWithoutTime(b["bin_installation_date"]),
        last_collection: b["Bin_live_Data"].last_collection_time,
        last_update: b["Bin_live_Data"].Transmission_data.last_transmission_time,
        status: b["Bin_live_Data"].fill_level_percent,
        avg_rate: b["Bin_live_Data"].average_daily_fill_rate_in_percent,
        avg_usage_rate: moment(b["Bin_live_Data"].Transmission_data.expected_transmission_time).format("YYYY-MM-DD 00:00:00").valueOf() < moment().format("YYYY-MM-DD 00:00:00").valueOf() ? 0 : (b["Bin_live_Data"].average_daily_usage_rate_in_percent != null ? Number(b["Bin_live_Data"].average_daily_usage_rate_in_percent) : -1),
        collection_mode: Number(b["Bin_Restrictions"]["collection_mode"]),
        removed_reason: b["Bin_Restrictions"]["collection_mode"] == 1 ? b["Bin_Restrictions"]["removed_bin_reason_type_name"] : "",
        collection_frequency: b["Bin_live_Data"].bin_collection_or_refill_rate ? Number(b["Bin_live_Data"].bin_collection_or_refill_rate.toFixed(0)) : -1,
        predicted_time_for_max_allowed_capacity: this.currentLang != 'iw' ? (b["Bin_live_Data"].predicted_time_for_max_allowed_capacity ? this.utilService.convertDateEnglishWithoutTime(b["Bin_live_Data"].predicted_time_for_max_allowed_capacity) : '') : (b["Bin_live_Data"].predicted_time_for_max_allowed_capacity ? this.utilService.convertDateHebrewWithoutTime(b["Bin_live_Data"].predicted_time_for_max_allowed_capacity) : ''),
        blackStatus_csv: '',
        collection_days_csv: '',
        removed_reason_hebrew: b["Bin_Restrictions"]["collection_mode"] == 1 ? b["Bin_Restrictions"]["removed_bin_reason_type_name_hebrew"] : "",
        collection_days: b["collection_days"],
        active_collection_days: b["active_collection_days"],
        green_status_level_percent: b["Bin_thresholds"].green_status_fill_level_in_percent,
        yellow_status_level_percent: b["Bin_thresholds"].yellow_status_fill_level_in_percent,
        red_status_level_percent: b["Bin_thresholds"].red_status_fill_level_in_percent,
        bin_max_volume_in_liters: b["Bin_thresholds"].bin_max_volume_in_liters,
        bin_capacity_to_display: this.capacityDisplayType != 0 ? b["Bin_live_Data"].fill_level_percent * b["Bin_thresholds"].bin_max_capacity_in_liters / 100 + "%" : b["Bin_live_Data"].fill_level_percent + "%",
        Bin_Restrictions: b["Bin_Restrictions"],
        Bin_thresholds: b["Bin_thresholds"],
        bin_color: b["Bin_live_Data"]["color_status_name"],
        cluster_id: b["cluster_id"],
        site_id: b["site_id"],
        over_flow_dates: b["over_flow_dates"] ? b["over_flow_dates"][0].event_num_of_day : 0,
        analysis_time_span_in_days: b["analysis_time_span_in_days"] ? b["analysis_time_span_in_days"] : 0,
        cluster_avg: b["cluster_avg"],
        number_of_bins_in_cluster: b["number_of_bins_in_cluster"],
        calcDiff_lastCollection: b["calcDiff_lastCollection"],
        calcDiff_lastUpdate: b["calcDiff_lastUpdate"],
        installation_DateTime_value: moment(b["bin_installation_date"]).format("YYYY-MM-DD HH:mm:ss").valueOf(),
        predicted_time_for_max_allowed_capacity_value: moment(b["Bin_live_Data"].predicted_time_for_max_allowed_capacity).format("YYYY-MM-DD HH:mm:ss").valueOf(),
        chosenCluster: b["chosenCluster"],
        isOpenTicket: b["isOpenTicket"],
        Bin_live_Data: b["Bin_live_Data"],
        Bin_location: b["Bin_location"]
      };
    });

    this.binsData = binsFiltered;
    this.sortData({ direction: 'desc', active: 'bin_name' });
    this.updateTableData();
    this.preSelectChosenBins();
    this.cd.detectChanges();
  }

  preSelectChosenBins() {
    this.selection.clear();
    if (this.data && this.data.chosenBins && this.data.chosenBins.length > 0) {
      const chosenBinIds = this.data.chosenBins.map((bin: any) => bin.bin_id.toString());
      this.binsData.forEach((bin: any) => {
        if (chosenBinIds.includes(bin.bin_id.toString())) {
          this.selection.select(bin);
        }
      });
    }
  }

  sortData(sort: Sort) {
		let emptyLastCollectionArr :any = [];
		let emptyLastUpdateArr :any = [];
		let emptyNeighborhood :any = [];
		const data = this.binsData.slice();
		if (!sort.active || sort.direction === '') {
			this.binsData = data;
			this.updateTableData();
			return;
		}
		this.binsData = data.sort((a, b) => {
			const isAsc = sort.direction === 'asc';
			if ((sort.active === 'last_collection') || (sort.active === 'last_update')) {
				return sort.active ? this.compareDates(a[sort.active], b[sort.active], isAsc) : 0;
			} else {
				return sort.active ? this.compare(a[sort.active], b[sort.active], isAsc) : 0;
			}
		});

		if(this.binsData.length > 0 && ((sort.active === 'last_collection'))){
			_.each(this.binsData, (item) => {
				if(item.last_collection == "" || item.last_collection == null){
					emptyLastCollectionArr.push(item);
				}
			});
			this.binsData = _.remove(this.binsData, function(n) { 
				return n.last_collection != "" && n.last_collection != null;
			})

			if(sort.direction === 'asc'){
				this.binsData = [...emptyLastCollectionArr, ...this.binsData]
			}else{
				this.binsData = [...this.binsData, ...emptyLastCollectionArr]
			} 
		}else if(this.binsData.length > 0 && ((sort.active === 'last_update'))){
			_.each(this.binsData, (item) => {
				if(item.last_update == "" || item.last_update == null){
					emptyLastUpdateArr.push(item);
				}
			});
			this.binsData = _.remove(this.binsData, function(n) { 
				return n.last_update != "" && n.last_update != null;
			})

			if(sort.direction === 'asc'){
				this.binsData = [...emptyLastUpdateArr, ...this.binsData]
			}else{
				this.binsData = [...this.binsData, ...emptyLastUpdateArr]
			} 
		}else if(this.binsData.length > 0 && ((sort.active === 'neighborhood'))){
			_.each(this.binsData, (item) => {
				if(item.neighborhood == "" || item.neighborhood == null){
					emptyNeighborhood.push(item);
				}
			});
			this.binsData = _.remove(this.binsData, function(n) { 
				return n.neighborhood != "" && n.neighborhood != null;
			})

			if(sort.direction === 'asc'){
				this.binsData = [...emptyNeighborhood, ...this.binsData]
			}else{
				this.binsData = [...this.binsData, ...emptyNeighborhood]
			} 
		}
		this.updateTableData();
	}

  compare(a:any, b:any, isAsc:any) {
		return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
	}

	compareDates(a:any, b:any, isAsc:any) {
		const date1 = moment(a);
		const date2 = moment(b);
		return (date1.isBefore(date2) ? -1 : 1) * (isAsc ? 1 : -1);
	}

  getCollectionDays(flag: any) {
    if (flag) {
      this.showLoadingForCollectionDays = true;
    }
    this.apiService.GetBinsWeeklyCollectionSchedule(0)?.pipe(takeUntil(this.destroy$)).subscribe((v: any) => {
      if (flag) {
        this.showLoadingForCollectionDays = false;
      }
      _.each(this.binsBackUp, (basicBin) => {
        let collectionDays = [
          {
            sunday: 0,
            monday: 0,
            tuesday: 0,
            wednesday: 0,
            thursday: 0,
            friday: 0,
            saturday: 0
          }
        ];
        _.each(v.SitesWeeklyCollectionSchedule, (site) => {
          _.each(site.bins_weekly_collections_list, (bin) => {
            _.each(bin, (item) => {
              if (item.bin_id == basicBin["bin_id"] && site.site_id == basicBin["site_id"]) {
                let count = 0;
                collectionDays[0].sunday = item.sunday;
                collectionDays[0].monday = item.monday;
                collectionDays[0].tuesday = item.tuesday;
                collectionDays[0].wednesday = item.wednesday;
                collectionDays[0].thursday = item.thursday;
                collectionDays[0].friday = item.friday;
                collectionDays[0].saturday = item.saturday;
                _.each(Object.values(collectionDays[0]), (value) => {
                  if (value == 1) {
                    count++;
                  }
                });
                basicBin["collection_days"] = collectionDays;
                basicBin["active_collection_days"] = count;
              }
            });
          });
        });

        if (basicBin["collection_days"] == null) {
          basicBin["collection_days"] = collectionDays;
          basicBin["active_collection_days"] = 0;
        }
      });
      if (flag) {
        this.initBinsTable(this.binsBackUp);
      }
    });
  }

  calcDiff = (date: string) => {
    if (this.translationsObj && date) {
      if (date == "" || date == null) {
        return "";
      }
      let diff_in_string = '';
      const original_date = moment(date);
      const date_time_now = moment();
      if (new Date(moment(date).format("YYYY-MM-DD HH:mm:ss")).getTime() > new Date(moment().format("YYYY-MM-DD HH:mm:ss")).getTime()) {
        return this.translationsObj.COLLECTION_REPORT.NOW;
      }
      const diff_in_object: any = this.utilService.preciseDiffBetweenDates(original_date, date_time_now, true);
      if (diff_in_object.months > 0) {
        diff_in_string = diff_in_string + diff_in_object.months + ' ';
        if (diff_in_object.months == 1) {
          diff_in_string += this.translationsObj.COLLECTION_REPORT.MONTH + ' ';
        } else {
          diff_in_string += this.translationsObj.COLLECTION_REPORT.MONTHS + ' ';
        }
        if (diff_in_object.days > 0) {
          if (diff_in_object.days == 1) {
            diff_in_string += this.translationsObj.COLLECTION_REPORT.AND + ' ' + diff_in_object.days + ' ' + this.translationsObj.COLLECTION_REPORT.DAY;
          } else {
            diff_in_string += this.translationsObj.COLLECTION_REPORT.AND + ' ' + diff_in_object.days + ' ' + this.translationsObj.COLLECTION_REPORT.DAYS;
          }
        }
      } else if (diff_in_object.days > 0) {
        diff_in_string = diff_in_string + diff_in_object.days + ' ';
        if (diff_in_object.days == 1) {
          diff_in_string += this.translationsObj.COLLECTION_REPORT.DAY + ' ';
        } else {
          diff_in_string += this.translationsObj.COLLECTION_REPORT.DAYS + ' ';
        }
        if (diff_in_object.hours > 0) {
          if (diff_in_object.hours == 1) {
            diff_in_string += this.translationsObj.COLLECTION_REPORT.AND + ' ' + diff_in_object.hours + ' ' + this.translationsObj.COLLECTION_REPORT.HOUR;
          } else {
            diff_in_string += this.translationsObj.COLLECTION_REPORT.AND + ' ' + diff_in_object.hours + ' ' + this.translationsObj.COLLECTION_REPORT.HOURS;
          }
        }
      } else if (diff_in_object.hours > 0) {
        diff_in_string = diff_in_string + diff_in_object.hours + ' ';
        if (diff_in_object.hours == 1) {
          diff_in_string += this.translationsObj.COLLECTION_REPORT.HOUR + ' ';
        } else {
          diff_in_string += this.translationsObj.COLLECTION_REPORT.HOURS + ' ';
        }
        if (diff_in_object.minutes > 0) {
          if (diff_in_object.minutes == 1) {
            diff_in_string += this.translationsObj.COLLECTION_REPORT.AND + ' ' + diff_in_object.minutes + ' ' + this.translationsObj.COLLECTION_REPORT.MINUTE;
          } else {
            diff_in_string += this.translationsObj.COLLECTION_REPORT.AND + ' ' + diff_in_object.minutes + ' ' + this.translationsObj.COLLECTION_REPORT.MINUTES;
          }
        }
      } else if (diff_in_object.minutes > 0) {
        if (diff_in_object.minutes == 1) {
          diff_in_string += diff_in_object.minutes + ' ' + this.translationsObj.COLLECTION_REPORT.MINUTE;
        } else {
          diff_in_string += diff_in_object.minutes + ' ' + this.translationsObj.COLLECTION_REPORT.MINUTES;
        }
      }

      if (this.currentLang != 'iw') {
        diff_in_string += ' ' + this.translationsObj.COLLECTION_REPORT.AGO;
      }
      else {
        diff_in_string = this.translationsObj.COLLECTION_REPORT.AGO + ' ' + diff_in_string;
      }

      return diff_in_string;
    }
  }
}
